<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogAddClient"
    :before-close="doClose"
    width="60%"
    top="5vh"
  >
    <el-form ref="gsnForm" :rules="rules" :model="gsnForm" label-width="200px">
      <el-form-item prop="brandCode" :label="$t('title.brand')">
        <el-select style="width: 200px" v-model="gsnForm.brandCode" :placeholder="$t('desc.select')">
          <el-option
            :label="brandInfo.brandName"
            :value="brandInfo.brandCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="gsn" :label="$t('desc.gatewaySN')">
        <el-input v-model="gsnForm.gsn" style="width: 200px"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button v-if="subButtonAuth" :loading="loading" type="success" @click="onSubBtn('gsnForm')">{{$t("button.confirm")}}</el-button>
        <el-button @click="doClose">{{$t("button.cancel")}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {getBrandInfos} from "../../../api/api"
export default {
  name: "index",
  props: {
    loading:false,
    subButtonAuth: false,
    dialogAddClient: false,
    title: "",
    gsnForm: {
      gsn: "",
      gatewayName:"",
      softwareVersion: "",
      sIMNumber: "",
      signalLevel: "",
      girmwareId: "",
      location: "",
      networkType: "",

    },
  },
  data(){
    return{
      rules:{
        brandCode:[{required:true, message: this.$t('tips.needed'), trigger: ['blur','change']}],
        gsn:[{required:true, message: this.$t('tips.needed'), trigger: 'blur'}],
        // modelList:[{required:true, message: '不能为空', trigger: ['blur','change']}],
        // customerId:[{required:true, message: '不能为空', trigger: ['blur','change']}],
      },
      brandInfo:{},
    }
  },
  async mounted(){
    this.getBrandInfos();
  },
  methods: {
    async getBrandInfos(){
      let that=this;
      let res = await getBrandInfos();
      let brandCode=localStorage.getItem("user_brand")?localStorage.getItem("user_brand"):"IR";
      that.brandInfo = res.result.find(x=>x.brandCode==brandCode);
    },
    onSubBtn(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          this.$emit("onSubBtn", true);
        } else {
          return false;
        }
      });
    },
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      this.$refs.gsnForm.resetFields();
    },
  },
};
</script>

<style>
</style>
